import { Link } from 'react-router-dom';
import logo from '@/assets/images/logo_black.png'

export default function Footer() {
  const footerLinks = {
    company: [
      { name: '회사 소개', path: '/about' },
      { name: '사업 영역', path: '/services' },
      { name: '프로젝트', path: '/projects' },
    ],
    services: [
      { name: 'AI · Data R&D', path: '/services' },
      { name: 'System Reconstruction', path: '/services' },
      { name: 'Custom Solution', path: '/services' },
    ],
    support: [
      { name: '바우처 사업', path: '/voucher' },
      { name: '채용', path: '/recruit' },
      { name: '문의', path: '/contact' },
    ],
  };

  return (
    <footer className="bg-[#F0FDFA] border-t border-[#99F6E4]/30">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div>
            <img
              src={logo}
              alt="4-lab" 
              className="h-8 mb-4"
            />
            <p className="text-sm text-gray-600 leading-relaxed">
              AI와 데이터로<br />
              현장의 문제를 해결하는<br />
              R&D 전문 기업
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-gray-900 mb-4">회사</h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-gray-600 hover:text-[#0D9488] transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-gray-900 mb-4">사업 영역</h4>
            <ul className="space-y-3">
              {footerLinks.services.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-sm text-gray-600 hover:text-[#0D9488] transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-gray-900 mb-4">지원</h4>
            <ul className="space-y-3">
              {footerLinks.support.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-gray-600 hover:text-[#0D9488] transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-[#99F6E4]/30">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm text-gray-600 mb-4 md:mb-0">
              © 2026 4-lab. All rights reserved.
            </p>

          </div>
        </div>
      </div>
    </footer>
  );
}
